
import React, { forwardRef } from 'react'

import './InputDropdownToggle.scss'

interface Props {
  children: any
  onClick: (e: any) => void
  onClear: (e: any) => void
}

const InputDropdownToggleSelected = forwardRef(({ children, onClick, onClear }: Props, ref: any) => {

  return (
    <div
      ref={ref}
      className='input-dropdown-toggle selected'
      onClick={(e) => {
        e.preventDefault();
        onClick(e);
      }}
    >
      <div>
        {children}
      </div>
      <button
        onClick={(e: any) => {
          e.preventDefault()
          e.stopPropagation()

          onClear(e)
        }}
      >
        <span className="icon-cancelar" />
      </button>
    </div>
  )
})

InputDropdownToggleSelected.displayName = 'InputDropdownToggleSelected'

export default InputDropdownToggleSelected
